// AUTO-GENERATED from curriculum-gen/pilots/*_published.json — real CKLA-aligned templates.
// Regenerate with: cd curriculum-gen && python -m src.gen_catalog
import { RGRLesson } from './rgr-lessons';

export const CURRICULUM_PILOT_LESSONS: RGRLesson[] = [
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Kindergarten Domain 1 \u2014 Nursery Rhymes and Fables",
    "skill": "Composition",
    "grade": "K",
    "gradeBand": "Kindergarten",
    "title": "My Favorite Nursery Rhyme",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/0gNjo284YD",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Kindergarten Domain 10 \u2014 Colonial Towns and Townspeople",
    "skill": "Composition",
    "grade": "K",
    "gradeBand": "Kindergarten",
    "title": "Life in a Colonial Town",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/gVv41yB40A",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Kindergarten Domain 11 \u2014 Taking Care of the Earth",
    "skill": "Composition",
    "grade": "K",
    "gradeBand": "Kindergarten",
    "title": "Taking Care of the Earth",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/VY7jQQ6jD1",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Kindergarten Domain 12 \u2014 Presidents and American Symbols",
    "skill": "Composition",
    "grade": "K",
    "gradeBand": "Kindergarten",
    "title": "Our American Symbols",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/NqMJRGa4a9",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Kindergarten Domain 2 \u2014 The Five Senses",
    "skill": "Composition",
    "grade": "K",
    "gradeBand": "Kindergarten",
    "title": "My Five Senses",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/xMK49pbJ08",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Kindergarten Domain 3 \u2014 Stories",
    "skill": "Composition",
    "grade": "K",
    "gradeBand": "Kindergarten",
    "title": "A Story I Love",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/mWKje2zw6o",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Kindergarten Domain 4 \u2014 Plants",
    "skill": "Composition",
    "grade": "K",
    "gradeBand": "Kindergarten",
    "title": "How a Plant Grows",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/DMOJB20J8N",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Kindergarten Domain 5 \u2014 Farms",
    "skill": "Composition",
    "grade": "K",
    "gradeBand": "Kindergarten",
    "title": "On the Farm",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/051JqoRjKA",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Kindergarten Domain 6 \u2014 Native Americans",
    "skill": "Composition",
    "grade": "K",
    "gradeBand": "Kindergarten",
    "title": "Native Americans Long Ago",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/ybOJ0NpjzR",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Kindergarten Domain 7 \u2014 Kings and Queens",
    "skill": "Composition",
    "grade": "K",
    "gradeBand": "Kindergarten",
    "title": "Kings and Queens",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/o8zwV0m40N",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Kindergarten Domain 8 \u2014 Seasons and Weather",
    "skill": "Composition",
    "grade": "K",
    "gradeBand": "Kindergarten",
    "title": "My Favorite Season",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/A5Dwm06jOY",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Kindergarten Domain 9 \u2014 Columbus and the Pilgrims",
    "skill": "Composition",
    "grade": "K",
    "gradeBand": "Kindergarten",
    "title": "A Long Journey Across the Sea",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/7oQj3mYJYB",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Animals & Habitats \u00b7 Freshwater",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "Animals of Ponds and Rivers",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/BgXJbYbwWD",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Animals & Habitats \u00b7 Protecting Habitats",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "Protecting Animals and Their Homes",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/0Z2jnLaJ98",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Animals & Habitats \u00b7 The African Savanna",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "Animals of the Savanna",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/KD8jKZl4XW",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Animals & Habitats \u00b7 The Arctic",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "Animals of the Arctic",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/VY7jQobJD1",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Animals & Habitats \u00b7 The Forest",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "Animals of the Forest",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/p7N4AZyjRe",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Animals & Habitats \u00b7 The Ocean",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "Animals of the Ocean",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/p9Rjkg6jry",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Animals & Habitats \u00b7 The Rainforest",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "Animals of the Rainforest",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/0M5jYd24l2",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Animals & Habitats \u00b7 The Sonoran Desert",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "Animals of the Desert",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/NqMJRzxJa9",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Animals & Habitats \u00b7 What Is a Habitat?",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "What Is a Habitat?",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/gVv41eR40A",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 1 Benchmark Advance \u00b7 Unit 10: Exploring Sound",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "How We Make and Hear Sound",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/EmRjDD0j0r",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 1 Benchmark Advance \u00b7 Unit 1: Living Things Grow & Change",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "How a Living Thing Grows",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/eQKw6BQwPX",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 1 Benchmark Advance \u00b7 Unit 2: Animals & Their Stories",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "All About an Animal",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/dqKwEA0wmx",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 1 Benchmark Advance \u00b7 Unit 3: Being Part of a Community",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "How We Stay Safe Together",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/37z4zZO4dx",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 1 Benchmark Advance \u00b7 Unit 4: Characters in Stories",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "My Favorite Character",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/bvpJd514d8",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 1 Benchmark Advance \u00b7 Unit 5: Technology Helps Us",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "A Machine That Helps People",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/3YZwZ8m4kb",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 1 Benchmark Advance \u00b7 Unit 6: Stories Teach Us",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "The Problem in a Story",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/dXmJ2p2jaR",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 1 Benchmark Advance \u00b7 Unit 7: Past, Present & Future",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "Long Ago and Today",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/YVXwp9LJ0O",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 1 Benchmark Advance \u00b7 Unit 8: Observing the Sky",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "What I See in the Sky",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/KeVjNAY4d7",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 1 Benchmark Advance \u00b7 Unit 9: Goods & Services",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "Things We Buy and Use",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/yGLwvZYwkN",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Domain 1 \u2014 Fables and Stories",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "What a Fable Teaches Us",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/DYKwG2ojmA",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Domain 10 \u2014 A New Nation: American Independence",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "How America Began",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/yGLwvk5JkN",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Domain 11 \u2014 Frontier Explorers",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "Explorers of the Frontier",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/EmRjD2vJ0r",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Domain 2 \u2014 The Human Body",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "How My Body Works",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/eQKw625wPX",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Domain 3 \u2014 Different Lands, Similar Stories",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "A Story From Around the World",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/dqKwEDDjmx",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Domain 4 \u2014 Early World Civilizations",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "Life Along the River Long Ago",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/37z4z7Bjdx",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Domain 5 \u2014 Early American Civilizations",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "The Maya, Aztec, and Inca",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/bvpJd05Jd8",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Domain 6 \u2014 Astronomy",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "Our Place in Space",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/3YZwZ3aJkb",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Domain 7 \u2014 The History of the Earth",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "What's Inside the Earth",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/dXmJ2G34aR",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Domain 8 \u2014 Animals and Habitats",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "An Animal and Its Home",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/YVXwp2a40O",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 1 Domain 9 \u2014 Fairy Tales",
    "skill": "Composition",
    "grade": "1st",
    "gradeBand": "1st Grade",
    "title": "My Favorite Fairy Tale",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/KeVjNR1jd7",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Ancient Greece \u00b7 Alexander the Great",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Alexander the Great",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/0Z2jnGKw98",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Ancient Greece \u00b7 All for Sparta",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Life in Sparta",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/NqMJRLaja9",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Ancient Greece \u00b7 Athens and the Olive Tree",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "How Athens Got Its Name",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/KD8jKO6jXW",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Ancient Greece \u00b7 Athens: The Birthplace of Democracy",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Where Democracy Began",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/p7N4ALEJRe",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Ancient Greece \u00b7 Marathon",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Battle of Marathon",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/0M5jYkNJl2",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Ancient Greece \u00b7 Mount Olympus",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Home of the Greek Gods",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/gVv41zBj0A",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Ancient Greece \u00b7 The Ancient Greeks",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Who Were the Ancient Greeks?",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/7oQj3zY4YB",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Ancient Greece \u00b7 The Great Thinkers of Greece",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Great Thinkers of Greece",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/p9RjkoQjry",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Ancient Greece \u00b7 The Olympic Games",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The First Olympic Games",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/VY7jQP64D1",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Ancient Greece \u00b7 Thermopylae",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Stand at Thermopylae",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/BgXJbPljWD",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 2 Benchmark Advance \u00b7 Unit 10: States of Matter",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Solids, Liquids, and Gases",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/av24grDJN3",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 2 Benchmark Advance \u00b7 Unit 1: Plant & Animal Survival",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "How Living Things Survive",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/kyB4LAOjeV",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 2 Benchmark Advance \u00b7 Unit 2: Stories & Story Elements",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "A Character Who Faces a Challenge",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/BgXJbLbjWD",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 2 Benchmark Advance \u00b7 Unit 3: Government & Community Services",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "How Our Community Helps Us",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/p9RjkZ64ry",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 2 Benchmark Advance \u00b7 Unit 4: Folktales",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Lesson in a Folktale",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/0Z2jnZaj98",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 2 Benchmark Advance \u00b7 Unit 5: Inventions & Solving Problems",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "An Invention That Solves a Problem",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/PVG48DG4Nv",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 2 Benchmark Advance \u00b7 Unit 6: Tales Across Cultures",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "A Tale From Another Culture",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/qLd4OAvwO5",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 2 Benchmark Advance \u00b7 Unit 7: History & Primary Sources",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Learning From the Past",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/vXKj7VL4a2",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 2 Benchmark Advance \u00b7 Unit 8: Wind & Water Change the Land",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "How Wind and Water Shape the Land",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/07WwWb5jqv",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 2 Benchmark Advance \u00b7 Unit 9: Goods, Services & Money",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Goods, Services, and How We Trade",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/VPgjMAojO6",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Domain 11 \u2014 Immigration",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Coming to America",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/37z4zBB4dx",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Domain 12 \u2014 Fighting for a Cause",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Fighting for What's Right",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/bvpJda54d8",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 2 EL Education \u00b7 Module 1: Schools and Community",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "How Our Community Works Together",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/07WwWz9jqv",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 2 EL Education \u00b7 Module 1: Schools and Community (Opinion)",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "What Makes a Good Community Member?",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/bvpJdkewd8",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 2 EL Education \u00b7 Module 2: Fossils (How They Form)",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "How a Fossil Forms",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/3YZwZAgjkb",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 2 EL Education \u00b7 Module 2: Fossils Tell of Earth's Changes",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "What Fossils Tell Us",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/VPgjMZ9wO6",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 2 EL Education \u00b7 Module 3: Pollination (A Pollinator)",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "All About a Pollinator",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/dXmJ251waR",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 2 EL Education \u00b7 Module 3: The Secret World of Pollination",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "How Pollination Works",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/av24gO24N3",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 2 EL Education \u00b7 Module 4: Providing for Pollinators",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "How We Can Help Pollinators",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/ZxzwllKw9r",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 2 EL Education \u00b7 Module 4: Providing for Pollinators (How to Help)",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "How to Build a Pollinator Garden",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/YVXwpayJ0O",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Early Asian Civ \u00b7 Buddhists and Buddhism",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Story of the Buddha",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/0gNjo38jYD",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Early Asian Civ \u00b7 China's Great Wall",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Why China Built the Great Wall",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/ybOJ0VpjzR",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Early Asian Civ \u00b7 Chinese New Year",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Celebrating Chinese New Year",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/A5DwmG64OY",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Early Asian Civ \u00b7 Confucius",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Wise Teacher Confucius",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/o8zwVxm40N",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Early Asian Civ \u00b7 Diwali",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Diwali, the Festival of Lights",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/EmRjDXvj0r",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Early Asian Civ \u00b7 Hindus and Hinduism",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "What Hindus Believe",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/YVXwpGaj0O",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Early Asian Civ \u00b7 Paper, Writing, and Calligraphy",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "A Gift From Ancient China: Paper",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/mWKje5zj6o",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Early Asian Civ \u00b7 The Blind Men and the Elephant",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Blind Men and the Elephant",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/yGLwv15jkN",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Early Asian Civ \u00b7 The Importance of Silk",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Secret of Silk",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/051JqGRjKA",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Early Asian Civ \u00b7 The Indus River Valley, Part I",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Life Along the Indus River",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/3YZwZnawkb",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Early Asian Civ \u00b7 The Indus River Valley, Part II",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Cities of the Indus",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/dXmJ2D3jaR",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Early Asian Civ \u00b7 The Magic Paintbrush",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Magic Paintbrush",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/DMOJBa0w8N",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Early Asian Civ \u00b7 The Tiger, the Brahman, and the Jackal",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Clever Jackal",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/KeVjNM14d7",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Early Asian Civ \u00b7 The Yellow and the Yangtze Rivers",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "China's Two Great Rivers",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/xMK498bJ08",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Fairy Tales & Tall Tales \u00b7 Beauty and the Beast",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Beauty and the Beast",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/vXKj7QLJa2",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Fairy Tales & Tall Tales \u00b7 John Henry",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "John Henry and His Hammer",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/av24gOD4N3",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Fairy Tales & Tall Tales \u00b7 Paul Bunyan",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Tall Tale of Paul Bunyan",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/07WwWz5jqv",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Fairy Tales & Tall Tales \u00b7 Pecos Bill",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Tall Tale of Pecos Bill",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/VPgjMZowO6",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Fairy Tales & Tall Tales \u00b7 The Emperor's New Clothes",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Emperor's New Clothes",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/qLd4OpvjO5",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Fairy Tales & Tall Tales \u00b7 The Fisherman and His Wife",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Fisherman and His Wife",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/PVG48eGjNv",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Fighting for a Cause \u00b7 Cesar Chavez",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Cesar Chavez: Protector of Workers' Rights",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/eQKw6XQ4PX",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Fighting for a Cause \u00b7 Eleanor Roosevelt",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Eleanor Roosevelt: A Voice for Human Rights",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/y9XJXPqJek",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Fighting for a Cause \u00b7 Jackie Robinson",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Jackie Robinson: Champion of Equality",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/a29JrV1JnG",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Fighting for a Cause \u00b7 Mary McLeod Bethune",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Mary McLeod Bethune: A Dedicated Teacher",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/3P74xOxJY8",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Fighting for a Cause \u00b7 Rosa Parks",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Rosa Parks Took a Stand by Sitting Down",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/pAdJy75jOb",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Fighting for a Cause \u00b7 Susan B. Anthony",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Susan B. Anthony Fought for Women's Right to Vote",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/vxBJ55rJ5E",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Greek Myths \u00b7 Arachne the Weaver",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Arachne the Weaver",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/vXKj7Vq4a2",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Greek Myths \u00b7 Atalanta and the Golden Apples",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Atalanta and the Golden Apples",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/nX8JPAp49W",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Greek Myths \u00b7 Daedalus and Icarus",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Daedalus and Icarus",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/VPgjMAnjO6",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Greek Myths \u00b7 Demeter and Persephone",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Demeter and Persephone",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/qLd4OA8wO5",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Greek Myths \u00b7 Hercules",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Mighty Hercules",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/av24gr6JN3",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Greek Myths \u00b7 Oedipus and the Sphinx",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Riddle of the Sphinx",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/Zxzwl03w9r",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Greek Myths \u00b7 The Twelve Gods of Mount Olympus",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Twelve Gods of Olympus",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/PVG48nNwNv",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Greek Myths \u00b7 Theseus and the Minotaur",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Theseus and the Minotaur",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/07WwWbQjqv",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Immigration \u00b7 A Land of Opportunity",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "A Land of Opportunity",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/nX8JPnAj9W",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Immigration \u00b7 A Little Giant Comes to America",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Statue of Liberty Welcomes the World",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/07WwWl5Jqv",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Immigration \u00b7 Becoming a Citizen",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Becoming an American Citizen",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/kyB4L33JeV",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Immigration \u00b7 E Pluribus Unum",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Out of Many, One",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/vXKj7xLwa2",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Immigration \u00b7 From Ireland to New York City",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Coming From Ireland",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/av24gKD4N3",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Immigration \u00b7 Gold Mountain",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Journey From China",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/ZxzwlVd49r",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Immigration \u00b7 Life in the City",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Life in a Crowded City",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/VPgjMRowO6",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Immigration \u00b7 We the People",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "We the People",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/MWnwaVzJme",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Insects \u00b7 L1: Insects Everywhere!",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Insects Are Everywhere",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/vxBJ5z845E",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Insects \u00b7 L2: What Makes an Insect an Insect?",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "What Makes an Insect an Insect?",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/y9XJXb2jek",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Insects \u00b7 L3: Life Cycles of Insects",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Life Cycle of an Insect",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/3P74xQrjY8",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Insects \u00b7 L4: Social Insects: Bees and Wasps",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Bees and Wasps Live Together",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/a29JrGP4nG",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Insects \u00b7 L5: Social Insects: Ants and Termites",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Ants and Termites: Master Builders",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/pAdJyGNjOb",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Insects \u00b7 L6: Insects that Glow and Sing",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Insects That Glow and Sing",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/DYKwGbojmA",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Insects \u00b7 L7: Armored Tanks of the Insect World",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Armored Insects",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/eQKw6b5wPX",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Insects \u00b7 L8: Friend or Foe?",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Insects: Friend or Foe?",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/dqKwExDjmx",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 The Human Body \u00b7 A Healthy Human Body",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "How to Keep Your Body Healthy",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/7oQj3eRJYB",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 The Human Body \u00b7 A Well-Balanced Diet",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Eating a Well-Balanced Diet",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/A5DwmPyjOY",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 The Human Body \u00b7 Anton van Leeuwenhoek",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Scientist Who Saw Tiny Life",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/xMK49ya408",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 The Human Body \u00b7 Cells and Tissues",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Building Blocks of the Body",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/mWKjeV1w6o",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 The Human Body \u00b7 Nutrients",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Nutrients Your Body Needs",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/o8zwVgbJ0N",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 The Human Body \u00b7 Organs",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Body's Hardworking Organs",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/DMOJBdyj8N",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 The Human Body \u00b7 The Amazing Human Body",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Your Amazing Body",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/0gNjoVG4YD",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 The Human Body \u00b7 The Digestive System",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "How Your Body Digests Food",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/051JqVO4KA",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 The Human Body \u00b7 The Excretory System",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "How Your Body Removes Waste",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/ybOJ0gzwzR",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Unit 1 \u2014 Fairy Tales and Tall Tales",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "A Tall Tale Hero",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/KD8jKR64XW",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Unit 10 \u2014 The Human Body: Building Blocks and Nutrition",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Taking Care of Your Body",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/MWnwaQYwme",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Unit 2 \u2014 Early Asian Civilizations",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "A Story From Early Asia",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/vXKj7Nq4a2",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Unit 3 \u2014 Ancient Greek Civilization",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Life in Ancient Greece",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/07WwW0QJqv",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Unit 4 \u2014 Greek Myths",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "A Greek Myth Worth Telling",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/p7N4A2EjRe",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Unit 5 \u2014 The War of 1812",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "An Event From the War of 1812",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/VPgjM3nJO6",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Unit 6 \u2014 Cycles in Nature",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "A Cycle in Nature",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/av24gD6jN3",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Unit 7 \u2014 Westward Expansion",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Journey West",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/Zxzwl2349r",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Unit 8 \u2014 Insects",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "All About an Insect",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/nX8JP1p49W",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Unit 9 \u2014 The US Civil War",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Learning About the Civil War",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/kyB4LzOweV",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 War of 1812 \u00b7 Peace and Pirates",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Peace at Last",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/qLd4OpnjO5",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 War of 1812 \u00b7 The Battle After the War",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Battle of New Orleans",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/PVG48eEjNv",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Westward Expansion \u00b7 Going West",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Why People Went West",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/dqKwER0Jmx",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Westward Expansion \u00b7 Mr. Fulton's Journey",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Robert Fulton and the Steamboat",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/37z4zWOjdx",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Westward Expansion \u00b7 The Buffalo Hunters",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Buffalo and the Plains",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/EmRjDE0w0r",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Westward Expansion \u00b7 The Erie Canal",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Traveling the Erie Canal",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/bvpJdV1jd8",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Westward Expansion \u00b7 The Oregon Trail",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Westward on the Oregon Trail",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/YVXwpVL40O",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Westward Expansion \u00b7 The Pony Express",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Mail by Horse: The Pony Express",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/KeVjNbYjd7",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Westward Expansion \u00b7 The Story of Sequoyah",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Sequoyah Gave the Cherokee a Way to Write",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/3YZwZamjkb",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Westward Expansion \u00b7 The Trail of Tears",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "The Trail of Tears",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/dXmJ2P2jaR",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 2 Westward Expansion \u00b7 The Transcontinental Railroad",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Building the Transcontinental Railroad",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/yGLwvnYwkN",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Wit & Wisdom",
    "unit": "Grade 2 Wit & Wisdom \u00b7 Module 1: A Season of Change",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "How a Season Changes the World",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/gVv41YV40A",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Wit & Wisdom",
    "unit": "Grade 2 Wit & Wisdom \u00b7 Module 2: The American West",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Life in the American West",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/VY7jQ0y4D1",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Wit & Wisdom",
    "unit": "Grade 2 Wit & Wisdom \u00b7 Module 3: Civil Rights Heroes",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "A Civil Rights Hero",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/NqMJRDGja9",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Wit & Wisdom",
    "unit": "Grade 2 Wit & Wisdom \u00b7 Module 4: Good Eating",
    "skill": "Composition",
    "grade": "2nd",
    "gradeBand": "2nd Grade",
    "title": "Eating Well to Stay Healthy",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/KD8jKpOwXW",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 3 Benchmark Advance \u00b7 Unit 10: Forces & Motion",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "How Forces Make Things Move",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/DYKwGAX4mA",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 3 Benchmark Advance \u00b7 Unit 1: Animal Adaptations",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "How Animals Adapt to Survive",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/Zxzwl0dw9r",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 3 Benchmark Advance \u00b7 Unit 2: Storytelling & Character Actions",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "What a Character's Actions Reveal",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/nX8JPAA49W",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 3 Benchmark Advance \u00b7 Unit 3: Civic Participation",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "How Citizens Make a Difference",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/kyB4LA3jeV",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 3 Benchmark Advance \u00b7 Unit 4: Character & Narrator",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "Seeing a Story Through the Narrator",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/MWnwaPzjme",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 3 Benchmark Advance \u00b7 Unit 5: Inventions & Communication",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "An Invention That Changed How We Communicate",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/vxBJ5Drw5E",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 3 Benchmark Advance \u00b7 Unit 6: Realistic Fiction & Choices",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "A Character Who Makes a Hard Choice",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/y9XJXkqwek",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 3 Benchmark Advance \u00b7 Unit 7: Communities Around the World",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "What Makes a Community Special",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/3P74xVxwY8",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 3 Benchmark Advance \u00b7 Unit 8: Weather & Climate",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "Weather, Climate, and How They Work",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/a29JrZ1JnG",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 3 Benchmark Advance \u00b7 Unit 9: Economics & Choices",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "Making Smart Economic Choices",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/pAdJyZ54Ob",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 3 EL Education \u00b7 Module 1: Overcoming Challenges (Narrative)",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "A Time I Overcame a Challenge",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/KeVjNDLJd7",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 3 EL Education \u00b7 Module 1: Overcoming Learning Challenges",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "Overcoming a Challenge",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/nX8JPNvj9W",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 3 EL Education \u00b7 Module 2: Adaptations & the World of Frogs",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "How Frogs Adapt to Survive",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/kyB4L2mweV",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 3 EL Education \u00b7 Module 2: Frogs (Life Cycle)",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "The Life Cycle of a Frog",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/yGLwvG2JkN",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 3 EL Education \u00b7 Module 3: Exploring Literary Classics",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "A Classic Story Worth Telling",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/MWnwazMJme",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 3 EL Education \u00b7 Module 3: Literary Classics (Opinion)",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "The Best Character in a Classic Story",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/EmRjDpGj0r",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 3 EL Education \u00b7 Module 4: Water Around the World",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "Why Water Matters Around the World",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/y9XJXz8jek",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 3 EL Education \u00b7 Module 4: Water Around the World (Opinion)",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "Should We Do More to Protect Clean Water?",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/0gNjoL6wYD",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 3 Unit 1 \u2014 Classic Tales: The Wind in the Willows",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "My Favorite Character in the Story",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/vxBJ52845E",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 3 Unit 2 \u2014 Classification of Animals",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "What Makes an Animal Group Special",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/nX8JPQV49W",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 3 Unit 3 \u2014 The Human Body",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "The Amazing Machine Inside You",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/kyB4LN5weV",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 3 Unit 4 \u2014 The Ancient Roman Civilization",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "Picture Life in Ancient Rome",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/BgXJbalwWD",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 3 Unit 5 \u2014 Light and Sound",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "How Light and Sound Travel",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/p9RjkrQ4ry",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 3 Unit 6 \u2014 The Viking Age",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "Life in the Viking Age",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/0Z2jnrKj98",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 3 Unit 7 \u2014 Astronomy: Our Solar System and Beyond",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "Amazing Things in Space",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/PVG483NJNv",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 3 Unit 8 \u2014 Native America",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "How Native Peoples Lived With the Land",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/qLd4OG84O5",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Wit & Wisdom",
    "unit": "Grade 3 Wit & Wisdom \u00b7 Module 1: The Sea",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "The Wonders of the Sea",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/p7N4ApDJRe",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Wit & Wisdom",
    "unit": "Grade 3 Wit & Wisdom \u00b7 Module 2: Outer Space",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "Exploring Outer Space",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/0M5jYDL4l2",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Wit & Wisdom",
    "unit": "Grade 3 Wit & Wisdom \u00b7 Module 3: A New Home",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "Starting Life in a New Home",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/BgXJbeYwWD",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Wit & Wisdom",
    "unit": "Grade 3 Wit & Wisdom \u00b7 Module 4: Artists Make Art",
    "skill": "Composition",
    "grade": "3rd",
    "gradeBand": "3rd Grade",
    "title": "How Artists Create Art",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/p9RjkMMJry",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 4 Benchmark Advance \u00b7 Unit 10: The Power of Electricity",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "How Electricity Powers Our World",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/gVv41lRJ0A",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 4 Benchmark Advance \u00b7 Unit 1: Observing Nature",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "What I Observed in Nature",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/0gNjoZG4YD",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 4 Benchmark Advance \u00b7 Unit 2: Characters' Actions and Reactions",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "How a Character's Reactions Drive the Story",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/xMK49Ya408",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 4 Benchmark Advance \u00b7 Unit 3: Government in Action",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "How Government Solves Problems",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/mWKjeX146o",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 4 Benchmark Advance \u00b7 Unit 4: Understanding Different Points of View",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "The Same Event, Different Points of View",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/DMOJBDyj8N",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 4 Benchmark Advance \u00b7 Unit 5: Technology for Tomorrow",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "A Technology That Could Shape the Future",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/051JqBO4KA",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 4 Benchmark Advance \u00b7 Unit 6: Confronting Challenges",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "A Character Who Confronts a Challenge",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/ybOJ0DzJzR",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 4 Benchmark Advance \u00b7 Unit 7: The Transcontinental Railroad",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "The Railroad That Connected a Nation",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/o8zwVAbj0N",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 4 Benchmark Advance \u00b7 Unit 8: Earth Changes",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "How Earth's Surface Changes",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/A5DwmVyJOY",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 4 Benchmark Advance \u00b7 Unit 9: Resources and Their Impact",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "How We Use Natural Resources",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/7oQj3LRwYB",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 4 EL Education \u00b7 Module 1: Poetry & Becoming Writers (Narrative)",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "Becoming a Writer",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/xMK49E1408",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 4 EL Education \u00b7 Module 1: Poetry, Poets & Becoming Writers",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "What Makes a Poem Powerful",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/vxBJ5eGJ5E",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 4 EL Education \u00b7 Module 2: Animal Defense Mechanisms",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "How Animals Defend Themselves",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/3P74x0Z4Y8",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 4 EL Education \u00b7 Module 2: Animal Defenses (Compare)",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "Comparing Two Animal Defenses",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/mWKjekvJ6o",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 4 EL Education \u00b7 Module 3: The American Revolution",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "A Turning Point in the Revolution",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/a29JrxgjnG",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 4 EL Education \u00b7 Module 3: The American Revolution (A Person)",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "A Person of the Revolution",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/DMOJBpbj8N",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 4 EL Education \u00b7 Module 4: 19th Amendment (Opinion)",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "Why the Right to Vote Matters",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/051Jq51JKA",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 4 EL Education \u00b7 Module 4: Ratifying the 19th Amendment",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "The Fight for Women's Right to Vote",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/pAdJy0DwOb",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 4 Unit 2 \u2014 The Middle Ages",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "Life in the Middle Ages",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/p9RjkrR4ry",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 4 Unit 4 \u2014 Islamic Empires in the Middle Ages",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "A Gift From the Islamic World",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/0Z2jnr1j98",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 4 Unit 5 \u2014 Eureka! Student Inventor",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "The Invention the World Needs",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/vXKj7XEwa2",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 4 Unit 6 \u2014 Geology",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "How the Earth Is Built",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/PVG483yJNv",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 4 Unit 7 \u2014 The American Revolution",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "A Turning Point in the Revolution",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/qLd4OVzJO5",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 4 Unit 8 \u2014 Treasure Island",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "The Most Exciting Part of the Story",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/y9XJX02Jek",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Wit & Wisdom",
    "unit": "Grade 4 Wit & Wisdom \u00b7 Module 1: A Great Heart",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "The Amazing Human Heart",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/0Z2jnPBJ98",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Wit & Wisdom",
    "unit": "Grade 4 Wit & Wisdom \u00b7 Module 2: Extreme Settings",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "Surviving an Extreme Setting",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/PVG486EwNv",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Wit & Wisdom",
    "unit": "Grade 4 Wit & Wisdom \u00b7 Module 3: The Redcoats Are Coming!",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "The Start of the American Revolution",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/qLd4O1nwO5",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Wit & Wisdom",
    "unit": "Grade 4 Wit & Wisdom \u00b7 Module 4: Myth Making",
    "skill": "Composition",
    "grade": "4th",
    "gradeBand": "4th Grade",
    "title": "The Lesson in a Myth",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/vXKj7Gdja2",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 5 Benchmark Advance \u00b7 Unit 10: Transforming Matter",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "How Matter Transforms",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/qLd4Okv4O5",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 5 Benchmark Advance \u00b7 Unit 1: Cultivating Natural Resources",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "Using Natural Resources Wisely",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/VY7jQ8b4D1",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 5 Benchmark Advance \u00b7 Unit 2: Developing Characters' Relationships",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "How a Relationship Changes in a Story",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/NqMJROx4a9",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 5 Benchmark Advance \u00b7 Unit 3: The U.S. Constitution: Then and Now",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "Why the Constitution Still Matters",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/KD8jKElJXW",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 5 Benchmark Advance \u00b7 Unit 4: Recognizing Author's Point of View",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "An Author's Point of View",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/p7N4AKywRe",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 5 Benchmark Advance \u00b7 Unit 5: Technology's Impact on Society",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "How a Technology Changed Society",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/0M5jYL24l2",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 5 Benchmark Advance \u00b7 Unit 6: Up Against the Wild",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "Surviving Against the Wild",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/BgXJbQbwWD",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 5 Benchmark Advance \u00b7 Unit 7: Conflicts That Shaped a Nation",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "A Conflict That Shaped Our Nation",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/p9RjkV64ry",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 5 Benchmark Advance \u00b7 Unit 8: Water: Fact and Fiction",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "The Science of Water",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/0Z2jnVaj98",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Benchmark Advance",
    "unit": "Grade 5 Benchmark Advance \u00b7 Unit 9: The Economic Development of Cities",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "How Cities Grow and Thrive",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/PVG48rGwNv",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 5 EL Education \u00b7 Module 1: Human Rights (Opinion)",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "The Human Right We Must Protect Most",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/ybOJ0LZJzR",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 5 EL Education \u00b7 Module 1: Stories of Human Rights",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "Standing Up for Human Rights",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/DYKwGZNjmA",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 5 EL Education \u00b7 Module 2: Biodiversity (Opinion)",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "Should We Do More to Protect the Rainforest?",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/o8zwVBnw0N",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 5 EL Education \u00b7 Module 2: Biodiversity in the Rainforest",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "Why the Rainforest's Biodiversity Matters",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/eQKw6e9jPX",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 5 EL Education \u00b7 Module 3: Athlete Leaders (A Leader)",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "What Makes a Great Leader",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/A5Dwml7jOY",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 5 EL Education \u00b7 Module 3: Athlete Leaders of Social Change",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "An Athlete Who Changed the World",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/dqKwEZEJmx",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 5 EL Education \u00b7 Module 4: Natural Disasters (Prepare)",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "How Communities Prepare for Disasters",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/7oQj3XMwYB",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "EL Education",
    "unit": "Grade 5 EL Education \u00b7 Module 4: The Impact of Natural Disasters",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "How Natural Disasters Affect People",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/37z4z05wdx",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 5 Unit 2 \u2014 Early American Civilizations",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "Two Great Civilizations of the Americas",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/07WwWkYwqv",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 5 Unit 4 \u2014 House on Mango Street",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "A Place That Matters to Me",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/3P74x8r4Y8",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 5 Unit 5 \u2014 Adventures of Don Quixote",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "What Don Quixote's Adventure Shows Us",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/a29JrBPJnG",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 5 Unit 6 \u2014 The Renaissance",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "An Idea That Changed the World",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/VPgjMoxJO6",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 5 Unit 7 \u2014 The Reformation",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "How New Ideas Spread",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/av24gAqwN3",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 5 Unit 8 \u2014 A Midsummer Night's Dream",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "Magic and Mix-Ups in the Forest",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/pAdJyONjOb",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Amplify CKLA",
    "unit": "Grade 5 Unit 9 \u2014 Native Americans",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "Living With the Land",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/Zxzwlrx49r",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Wit & Wisdom",
    "unit": "Grade 5 Wit & Wisdom \u00b7 Module 1: Cultures in Conflict",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "When Cultures Come Into Conflict",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/07WwWD9Jqv",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Wit & Wisdom",
    "unit": "Grade 5 Wit & Wisdom \u00b7 Module 2: Word Play",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "The Power of Word Play",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/VPgjMY9jO6",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Wit & Wisdom",
    "unit": "Grade 5 Wit & Wisdom \u00b7 Module 3: A War Between Us",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "How the Civil War Divided a Nation",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/av24g82jN3",
    "source": "pressto-authored",
    "isNew": true
  },
  {
    "brand": "Pressto",
    "program": "Wit & Wisdom",
    "unit": "Grade 5 Wit & Wisdom \u00b7 Module 4: Breaking Barriers",
    "skill": "Composition",
    "grade": "5th",
    "gradeBand": "5th Grade",
    "title": "Someone Who Broke a Barrier",
    "status": "live",
    "templateUrl": "https://www.joinpressto.com/templates/ZxzwlgKj9r",
    "source": "pressto-authored",
    "isNew": true
  }
];
